/* JnibError.js */

"use strict";

class JNIBError extends Error {
    constructor(message) {
        super(message);
        this.name = "JNIBError";
    }

    setMessage(value) {
        this.message = value;
        //TODO potentially clean up the stack here.
    }
}
module.exports = JNIBError;
